export function hasClassName(elem, className) {
    return elem.className.split(' ').indexOf(className) >= 0;
}

export function addClassName(elem, className) {
    elem.className = [...elem.className.split(' '), className].join(' ');
}

export function removeClassName(elem, className) {
    elem.className = elem.className
        .split(' ')
        .filter((name) => name !== className)
        .join(' ');
}

export function capitalize(str) {
    if (typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

document.addEventListener("DOMContentLoaded", function() {
    const toggleFilters = document.getElementById("rWpAlgoliaToggleFilters");
    const mobileFilters = document.getElementById("mobile-filters");
    const filterCloseButton = document.getElementById("filterCloseButton");
    const filterCloseButtonProducts = document.getElementById("filterCloseButtonProducts");
    const filterCatToggle = document.getElementById("toggle-refinement");
    const filterClearRefinements = document.getElementById("clear-refinements");
    const closeButtonWrapper = document.querySelector('.close-button-wrapper');
    const toggleRefinement = document.getElementById('toggle-refinement');

    if ( filterCloseButton ) {
        filterCloseButton.addEventListener("click", function () {
            toggleFilters.checked = false;
            mobileFilters.style.display = "none";
            // filterCatToggle.classList.remove("mobile-toggle-refinements");
            // filterClearRefinements.classList.remove("mobile-clear-refinements");
            if (closeButtonWrapper.classList.contains('hidden')) {
                closeButtonWrapper.classList.remove('hidden');
            }
            // if (toggleRefinement.classList.contains('hidden')) {
            //     toggleRefinement.classList.remove('hidden');
            // }
        });
    }

    if ( filterCloseButtonProducts ) {
        filterCloseButtonProducts.addEventListener("click", function () {
            toggleFilters.checked = false;
            mobileFilters.style.display = "none";
            document.querySelector('body').classList.remove('algolia-mobile-filters--open');
            // filterCatToggle.classList.remove("mobile-toggle-refinements");
            // filterClearRefinements.classList.remove("mobile-clear-refinements");

            if (closeButtonWrapper.classList.contains('hidden')) {
                closeButtonWrapper.classList.remove('hidden');
            }
            // if (toggleRefinement.classList.contains('hidden')) {
            //     toggleRefinement.classList.remove('hidden');
            // }

            // Remove .ais-Dropdown--opened class from elements with both .ais-Dropdown and .ais-Dropdown--opened classes
            const openedDropdowns = document.querySelectorAll('.ais-Dropdown.ais-Dropdown--opened');
            openedDropdowns.forEach(function (dropdown) {
                dropdown.classList.remove('ais-Dropdown--opened');
            });
        });
    }

    if ( toggleFilters ) {
        toggleFilters.addEventListener("change", function () {
            if (toggleFilters.checked) {
                const openFilters = document.querySelectorAll( '.ais-Dropdown--opened' );
                openFilters.forEach( ( openFilter ) => {
                    openFilter.classList.remove( 'ais-Dropdown--opened' )
                } );
                mobileFilters.style.display = "flex";
                document.querySelector('body').classList.add('algolia-mobile-filters--open');
                // filterCatToggle.classList.add("mobile-toggle-refinements");
                // filterClearRefinements.classList.add("mobile-clear-refinements");
            } else {
                mobileFilters.style.display = "none";
                document.querySelector('body').classList.remove('algolia-mobile-filters--open');
                // filterCatToggle.classList.remove("mobile-toggle-refinements");
                // filterClearRefinements.classList.remove("mobile-clear-refinements");
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const dropdowns = document.querySelectorAll('.ais-Dropdown');
    const closeButtonWrapper = document.querySelector('.close-button-wrapper');
    const toggleRefinement = document.getElementById('toggle-refinement');

    function toggleCloseButtonWrapper() {
        if (!closeButtonWrapper || !toggleRefinement) {
            return; // Exit the function if either element does not exist
        }

        let anyDropdownOpened = false;

        dropdowns.forEach(dropdown => {
            if (dropdown.classList.contains('ais-Dropdown--opened')) {
                anyDropdownOpened = true;
            }
        });

        if (anyDropdownOpened) {
            closeButtonWrapper.classList.add('hidden');
            toggleRefinement.classList.add('hidden');
            document.querySelectorAll('.era-wp-algolia__filter-dropdown').forEach(container => {
                const hasOpenedDropdown = container.querySelector('.ais-Dropdown--opened');
                if (!hasOpenedDropdown) {
                    container.classList.add('hidden');
                } else {
                    container.classList.remove('hidden');
                }
            });
        } else {
            closeButtonWrapper.classList.remove('hidden');
            toggleRefinement.classList.remove('hidden');
            document.querySelectorAll('.era-wp-algolia__filter-dropdown').forEach(container => {
                container.classList.remove('hidden');
            });
        }
    }

    // Set up a mutation observer to watch for class changes in all dropdowns
    if (closeButtonWrapper && toggleRefinement) {
        dropdowns.forEach(dropdown => {
            const observer = new MutationObserver(toggleCloseButtonWrapper);
            observer.observe(dropdown, { attributes: true, attributeFilter: ['class'] });
        });
    }
});



